<div class="screen">
  <div class="popup-container">
    <div class="icon-container-popup">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </div>
    <div class="popup-description">
      There are unsaved changes. <br> Do you want to Save and Proceed?
    </div>
    <div class="flex-center">
      <button class="btn btn-primary-soft" (click)="this.action('SAVE')">Yes</button>
      <button class="btn btn-light" (click)="this.action('SKIP')">No</button>
      <button class="btn btn-light" (click)="this.action('CANCEL')">Cancel</button>
    </div>
  </div>
</div>